export default {
  pageNotExist: 'This page is not exists, maybe you want to visit another page',
  backToHome: 'Back to home',
  somethingWrong: 'Oops, Something wrong, please refresh for another try',
  pleaseChoosePackage: 'Please choose package first before enter details',
  selectPaymentMethod: 'Select payment method',
  noPlanAvailable: 'No plan available',
  selectPackage: 'Select package',
  paymentSuccessful: 'SUCCESS',
  paymentFailed: 'FAILED',
  paymentCancelled: 'CANCEL',
  paymentPending: 'PENDING',
  paymentNone: 'UNKNOWN',
  paymentEnd: 'END',
  packageName: 'Package Name',
  service: 'Service',
  serviceExpiryDate: 'Service Expiry Date',
  paymentDetails: 'Payment Details',
  termAndCondition: 'Terms & Conditions',
  discountPriceSince: 'Deducted Price since you have already paid for ',
  originalAmount: 'Original Amount',
  carryOverFee: 'Carry Over Fee',
  total: 'Total',
  referenceNumber: 'Reference number',
  paymentStatus: 'Payment status',
  paymentMethod: 'Payment method',
  packagePlanDetail: 'Package plan details',
  payerDetail: 'Payer details',
  cannotCreateOrder: 'Cannot create order, please try again',
  cannotFindOrder: 'We can not find your order, please recheck Manabie app',
  statusOfPayment: 'The status for payment is ',
  insufficientData: ', but we are missing some data so we can not display it correctly. Please back to payment history for full details.',
  payerName: 'Payer name',
  payerPhoneNumber: 'Payer phone number',
  cannotFindThisUser: 'We can not find your information, please check payment status in payment history',
  packagePlanName: 'Package plan name',
  expiryDate: 'Expiry date',
  totalPayment: 'Total payment',
  paymentSummary: 'Payment summary',
  backToApp: 'Back to learning app',
  signIn: 'Sign in',
  goToPayment: 'Go to payment',
  oldOrderPending: 'An error has occurred! Your payment could not be processed due to recent Pending payment. Please check your transaction status history.',
  packagePeriod: 'Selected package expiry time is smaller than yours.',
  amountTooSmall: 'The payment value is too small.',
  packageNotFound: 'Selected package is not found.',
  downgradeDuration: 'Your package is on a "downgrade" time. Can not purchase at the moment. Please contact our customer support.',
  unknownError: 'Unknown error. Can you please report this to us. Thank you!',
  notFound: 'Entity is not found.',
  permissionDenied: 'Permission denied. Maybe you have not signed in yet.',
  internal: 'Internal server error. It is our fault, can you please report this?',
  disconnectFromServer: 'Server disconnected, please check your internet connection.',
  notAuthenticated: 'Your payment session time is up or you have not signed in yet',
  servicePeriod: 'Service period',
  verify: 'Verify',
  notThisAccount: 'Not this account',
  signOut: 'Sign out',
  youSignInAs: 'You are signed in as',
  goToPackage: 'Go to package',
  enterConfirmationCode: 'Enter your OTP',
  invalidConfirmationCode: 'Your OTP is not valid',
  recommended: 'Recommended',
  invalidPhoneNumber: 'Invalid phone number',
  redirectToGateway: 'Going to payment gateway',
  packageEnded: 'This package is already expired',
  pleaseSignIn: 'Please sign in',
  draftInvoice: 'Draft Invoice',
  weCanNotFindYourId: 'We can not find your id, please try again',
  invalidCredential: 'Invalid credential, please try sign out & sign in again',
  goBack: 'Go back',
  enterCode: 'Enter code',
  reducedBy: 'discounted by',
  apply: 'Apply',
  promotion: 'Promotion (Optional)',
  discount: 'Discount',
  noInternet: 'No internet',
  invalidPrams: 'Invalid parameters',
  atmCard: 'ATM Card/ Internet Banking',
  cod: 'Cash on Delivery',
  nationalWideDelivery: 'Nationalwide delivery service',
  ghnDesc: 'You need to provide us with the exact shipping address, phone number. After you confirm payment, your account will be activated right away. GHN delivery staff then will contact you to collect your payment.',
  thisFieldIsRequired: 'This field is required',
  fullName: 'Full name',
  shippingAddress: 'Shipping address',
  phoneNumber: 'Phone number',
  city: 'City',
  district: 'District',
  ward: 'Ward',
  pleaseFillForm: 'Please fill all information',
  confirmPayment: 'Confirm payment',
  payerInfo: 'Payer Information',
  thankYouForYourOrder: 'Thank you for your order!',
  pleaseReadThisBefore: 'Please read this before confirming your payment',
  iHave: 'I have ',
  readAndAgreed: 'read and agreed ',
  uponAbove: 'upon above.',
  close: 'Close',
  confirm: 'Confirm',
  codInstruct1: 'Your account will be activated right after you tap “Confirm” this payment.',
  codInstruct2: 'The GHN shipper will contact you to collect the fees of this package within 5 days.',
  codInstruct3: 'If you failed to make payment, your account will be deactivated.',
  pleaseTickOnCheckbox: 'Please tick on checkbox above',
  yourPaymentIsSuccessful: 'Your payment is successful.',
  enjoyLearningManabie: 'Enjoy your learning with Manabie.',
  yourPaymentIsFailed: 'Your payment is unsuccessful.',
  pleaseTryAgain: 'Please try again.',
  back: 'Back',
  payBefore: 'Pay before ',
  at: 'at ',
  processing: 'Processing',
  paymentInstruct1: 'Your account has been activated. You can start learning with Manabie!',
  paymentInstruct2: 'Within 5 days, the driver will call you and come to your house to collect cash.',
  paymentInstruct3: 'When the driver comes, give cash to the driver, and receive 8 digit code as a receipt.',
  paymentInstruct4: `If you need helps, please call ${process.env.SUPPORT_PHONE_NUMBER || '091-407-1517'} for customer support.`,
  howToPay: 'How to pay',
  days: 'days',
  day: 'day',
  hours: 'hours',
  hour: 'hour',
  minutes: 'minutes',
  minute: 'minute',
  goToSummary: 'Go to summary',
  expiringOn: 'Expiring on',
  visa: 'Visa/Mastercard',
  'you already have one order processing, can not create a new one': 'Sorry, you already have one order processing.',
  toDate: '$t({{month}}) {{day}} {{year}}',
  0: 'Jan', //todo: move to namespace
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'Jun',
  6: 'Jul',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec',
  'Please enter promo code': 'Please enter promo code',
  'This code has been entered incorrectly.': 'This code has been entered incorrectly.',
  'Sorry, this code has been expired.': 'Sorry, this code has been expired.',
  PAYMENT_METHOD_NONE: 'NONE',
  PAYMENT_METHOD_ATM: 'ATM',
  PAYMENT_METHOD_CREDIT_DEBIT_CARD: 'CREDIT/DEBIT',
  PAYMENT_METHOD_COD: 'COD',
  PAYMENT_METHOD_BANK_TRANSFER: 'BANK TRANSFER',
  PAYMENT_METHOD_IAP: 'IN-APP PURCHASE',
  Master: undefined, //preserve key for payment method display in summary,
  missingUpgradeCondition: 'You can not purchase this package, pleases contact our support',
  paymentProcessing: 'Processing',
  returnToPayment: 'Return to payment',
  paymentDeleted: 'deleted',
  paymentTimeout: 'Payment timeout, please create other payment',
  tryAgain2Time: 'Can not change payment method 2 times',
  rePurchasePayment: 'Can not purchase this order 2 times',
  orderNotFound: 'Order not found',
  cannotParseToken: 'Your credential is bad, please refresh from app',
  userNotExist: 'User is not exist in our system, please create in app first or change another account',
  'auth/account-exists-with-different-credential': 'Duplicated email or phone, did you register by different sign in method?',
  'auth/auth-domain-config-required': 'System error, domain is not in the right config. Please contact our staff',
  'auth/cancelled-popup-request': '',
  'auth/operation-not-allowed': 'Your account is not in enabled state. Please contact our staff',
  'auth/operation-not-supported-in-this-environment': 'Your browser is not in the support list for this login method',
  'auth/popup-blocked': 'Sign in popup is blocked',
  'auth/popup-closed-by-user': '',
  'auth/unauthorized-domain': 'Domain is not authorized. Please contact our staff',
  pleaseChooseYourPlan: 'Please choose your desired plan',
  enterYourPhoneNumber: 'Enter your phone number',
  socialSignOut: 'Your account does not exist in our system',
  retry: 'Retry'
}
